import PropTypes from 'prop-types'
import './StaleDataBanner.css'

/**
 * Inline banner shown when an action succeeds but data refresh fails.
 * Provides clear messaging and retry functionality.
 *
 * @param {Object} props
 * @param {boolean} props.show - Whether to show the banner
 * @param {Function} props.onRetry - Callback when user clicks "Refresh now"
 * @param {Function} props.onDismiss - Callback when user dismisses the banner
 * @param {string} props.className - Additional CSS classes (optional)
 * @param {Object} props.style - Inline styles (optional)
 */
export default function StaleDataBanner({
  show,
  onRetry,
  onDismiss,
  className = '',
  style = {},
}) {
  if (!show) return null

  return (
    <div className={`stale-data-banner ${className}`} style={style}>
      <div
        className="alert alert-warning alert-dismissible fade show mb-0"
        role="alert"
      >
        <strong>Note:</strong> Your action was successful, but we couldn't
        refresh the latest data.{' '}
        <button
          type="button"
          className="btn btn-sm btn-warning ms-2"
          onClick={onRetry}
          aria-label="Retry refreshing data"
        >
          Refresh now
        </button>
        <button
          type="button"
          className="btn-close"
          onClick={onDismiss}
          aria-label="Close"
        ></button>
      </div>
    </div>
  )
}

StaleDataBanner.propTypes = {
  show: PropTypes.bool.isRequired,
  onRetry: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
}

StaleDataBanner.defaultProps = {
  className: '',
  style: {},
}
